const RAPIDAPI_KEY = 'c49ee06b2fmsh6722d4fb13cbb5dp14ed9ejsn06c00c935147';
const RAPIDAPI_HOST = 'tiktok-downloader-download-tiktok-videos-without-watermark.p.rapidapi.com';

export const downloadTikTokVideo = async (url) => {
  try {
    // Encode the TikTok URL
    const encodedUrl = encodeURIComponent(url);
    
    const response = await fetch(
      `https://${RAPIDAPI_HOST}/index?url=${encodedUrl}`,
      {
        method: 'GET',
        headers: {
          'x-rapidapi-key': RAPIDAPI_KEY,
          'x-rapidapi-host': RAPIDAPI_HOST
        }
      }
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching TikTok video:', error);
    throw error;
  }
};

export const extractVideoInfo = (apiResponse) => {
  return {
    videoUrl: apiResponse.video?.[0] || null,
    videoWithWatermark: apiResponse.OriginalWatermarkedVideo?.[0] || null,
    musicUrl: apiResponse.music?.[0] || null,
    coverImage: apiResponse.cover?.[0] || null,
    dynamicCover: apiResponse.dynamic_cover?.[0] || null,
    author: apiResponse.author?.[0] || 'Unknown',
    description: apiResponse.description?.[0] || '',
    videoId: apiResponse.videoid?.[0] || '',
    region: apiResponse.region?.[0] || '',
    avatarThumb: apiResponse.avatar_thumb?.[0] || null,
    isVideo: apiResponse.is_video || false,
    postType: apiResponse.post_type || '',
    images: apiResponse.images || [],
    imagesCount: apiResponse.images_count || 0
  };
};
